import ReactDOM from 'react-dom/client';
import { AuthProvider } from './hooks/useAuth';
import App from './App';
import './styles/global.css';

// Intercepta fetch global para incluir Authorization em chamadas /api/*
// Garante que TODAS as requests da app levem o JWT do DopScale, sem precisar
// modificar cada fetch espalhado pelos componentes.
(function installFetchInterceptor() {
  const origFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isApi = url.startsWith('/api/') || url.includes('://') === false && url.startsWith('/api/');
    if (isApi) {
      const token = localStorage.getItem('adintel_token');
      if (token) {
        const headers = new Headers(init.headers || (typeof input !== 'string' && input.headers) || {});
        if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
        init = { ...init, headers };
      }
    }
    const res = await origFetch(input, init);
    if (res.status === 401 && isApi) {
      localStorage.removeItem('adintel_token');
      localStorage.removeItem('adintel_user');
      if (!window.location.pathname.includes('/login')) {
        window.location.reload();
      }
    }
    return res;
  };
})();

ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
